var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_7315_393891)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7315_393891)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.570312,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8047 21.499V22.6884V23.3097V24.499V27.999C26.8047 28.1348 26.6905 28.249 26.5547 28.249H14.5547C14.4189 28.249 14.3047 28.1348 14.3047 27.999V17.999C14.3047 17.8632 14.4189 17.749 14.5547 17.749H26.5547C26.6905 17.749 26.8047 17.8632 26.8047 17.999V21.499ZM28.085 23.9687L27.1153 22.999L28.085 22.0294L30.8047 19.3097V26.6884L28.085 23.9687Z",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.085,
    y1: 11.4687,
    x2: 34.7124,
    y2: 34.0961,
    stroke: "#707070",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_7315_393891",
    x: -15,
    y: -14.4297,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7315_393891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7315_393891",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7315_393891"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.570312,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDisable);
export default __webpack_public_path__ + "static/media/videoDisable.7b0a2d3b43be80e0e07f257eaefb05a0.svg";
export { ForwardRef as ReactComponent };